// Add your custom JS here.

// Adds class to the hedear when scrolled
jQuery(window).scroll(function () {
  if (jQuery(this).scrollTop() > 100) {
    jQuery("#wrapper-navbar").addClass("scroll");
  } else {
    jQuery("#wrapper-navbar").removeClass("scroll");
  }
});

window.addEventListener(
  "DOMContentLoaded",
  function (e) {
    document.querySelectorAll(".video-player").forEach(function (current) {
      var parentElement = current.parentElement;
      let videoid = current.dataset.videoid;

      /* load youtube thumbnail as background image */
      /*
      current.style.backgroundImage =
        "url(https://i3.ytimg.com/vi/" + videoid + "/hqdefault.jpg)";
      */

      /* insert iframe to hold video player */

      let playerFrame = document.createElement("IFRAME");
      playerFrame.setAttribute("webkitAllowFullScreen", "");
      playerFrame.setAttribute("mozAllowFullScreen", "");
      playerFrame.setAttribute("allowFullScreen", "");
      playerFrame.setAttribute("frameborder", 0);
      //current.appendChild(playerFrame);

      /* initialise click event to load video into iframe */

      parentElement.addEventListener("click", function (e) {
        playerFrame.style.display = "block";
        playerFrame.src =
          "https://www.youtube.com/embed/" + videoid + "?autoplay=1";
        //playButton.style.display = "none";
        e.preventDefault();

        var player;
        player = new YT.Player(current, {
          videoId: videoid,
          playerVars: {
            controls: 0,
            modestbranding: 1,
            playsinline: 1,
            rel: 0,
          },
          events: {
            onReady: onPlayerReady,
          },
        });

        parentElement.classList.add("video-player--playing");
      });
    });
  },
  false
);

function onPlayerReady(event) {
  console.log("onPlayerReady");
  event.target.playVideo();
}
